import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from "react-router-dom";
import { Box, Container, CssBaseline, Avatar, Typography, TextField, FormControlLabel, Button, Grid, Link, Checkbox, MenuItem, Alert, Card, CardContent } from '@mui/material'
import { AuthContext } from '../AuthProvider';
import backgroundImage from '../assets/fond_site.png'
import logoMinistre from '../assets/logo_officiel.png'
import LoginIcon from '@mui/icons-material/Login';
import { grey } from '@mui/material/colors';
function Login() {
    const { loginUser, user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [errorLogin, setErrorLogin] = useState(false)
    const [errorMessage, setErrorMessage] = useState(false)
    const [loading, setLoading] = useState(false)
    const handleSubmit = (e) => {
        e.preventDefault()
        setErrorLogin(false)
        setLoading(true)
        if (email != '' && password != '') {
            loginUser(email, password)
                .then((result) => {
                    if (result) {
                        navigate("/admin/");
                    } else {
                        setErrorLogin(true)
                        setErrorMessage('Nom d\'utilisateur ou mot de passe incorrect')
                        setLoading(false)
                    }
                })
                .catch((error) => {
                    setLoading(false)
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    setErrorLogin(true)
                    setErrorMessage('Nom d\'utilisateur ou mot de passe incorrect')
                    // ..
                });
        } else {
            setErrorLogin(true)
            setErrorMessage('Veuillez compléter les champs obligatoire!')
            setLoading(false)
        }
    };
    // if (loading) {
    //     return (
    //         <span className="loading loading-dots loading-lg flex item-center mx-auto"></span>
    //     );
    // }

    // If the user is already authenticated, redirect to the home page
    if (user != null) {
        navigate("/admin/");
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundImage: `url(${backgroundImage})`,
            backgroundPosition: 'center', /* Center the image */
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        }}>
            <Card sx={{
                maxWidth: { sm: 380, xs: 300 }
            }}>
                <CardContent sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <img src={logoMinistre} width={180} height={180} />
                    {/* <img src={logoMinistre} width="150" height="90"/> */}
                    <Typography component="h1" variant="h5">
                        Page d'authentification
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            onChange={(e) => {
                                setEmail(e.target.value)
                            }}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Mot de passe"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onChange={(e) => {
                                setPassword(e.target.value)
                            }}
                        />
                        {errorLogin && (
                            <Alert
                                severity="error"
                                variant="standard"
                                sx={{ width: '100%' }}
                            >
                                {errorMessage}
                            </Alert>
                        )}
                        <Button
                            fullWidth
                            variant="contained"
                            color='success'
                            sx={{ mt: 3, mb: 2, textTransform: "none" }}
                            onClick={handleSubmit}
                            startIcon={<LoginIcon />}
                            disabled={loading}
                            type='submit'>
                            Se connecter
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </div>
    )

}

export default Login